import { render } from "./UiTextarea.vue?vue&type=template&id=8bf9096a&ts=true"
import script from "./UiTextarea.vue?vue&type=script&lang=ts"
export * from "./UiTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__